import { useState, useEffect, useCallback } from 'react';
import { getRpcProviders, getEvmRpcProviderByChainId, getEvmDefaultRpcProvider, getSolanaDefaultRpcProvider } from '@dynamic-labs/multi-wallet';
import '@dynamic-labs/sdk-api';
import { logger } from '../../../shared/logger.js';
import '@dynamic-labs/iconic';
import 'react/jsx-runtime';
import '../../../context/ViewContext/ViewContext.js';
import '../../constants/colors.js';
import '../../../shared/consts/index.js';

const useRpcProviders = ({ networkConfigurations, }) => {
    const [providers, setProviders] = useState();
    const [evmDefaultProvider, setEvmDefaultProvider] = useState();
    const [solanaDefaultProvider, setSolanaDefaultProvider] = useState();
    useEffect(() => {
        try {
            if (networkConfigurations) {
                setProviders(getRpcProviders(networkConfigurations));
            }
        }
        catch (error) {
            logger.error(error);
        }
    }, [networkConfigurations]);
    const getEvmRpcProviderByChainId$1 = useCallback((chainId) => {
        if (!networkConfigurations) {
            return undefined;
        }
        return getEvmRpcProviderByChainId(networkConfigurations, chainId);
    }, [networkConfigurations]);
    useEffect(() => {
        try {
            if (networkConfigurations) {
                setEvmDefaultProvider(getEvmDefaultRpcProvider(networkConfigurations));
            }
        }
        catch (error) {
            logger.error(error);
        }
    }, [networkConfigurations]);
    useEffect(() => {
        try {
            if (networkConfigurations) {
                setSolanaDefaultProvider(getSolanaDefaultRpcProvider(networkConfigurations));
            }
        }
        catch (error) {
            logger.error(error);
        }
    }, [networkConfigurations]);
    return {
        evmDefaultProvider,
        evmProviders: providers === null || providers === void 0 ? void 0 : providers.evm,
        getEvmRpcProviderByChainId: getEvmRpcProviderByChainId$1,
        solanaDefaultProvider,
        solanaProviders: providers === null || providers === void 0 ? void 0 : providers.solana,
    };
};

export { useRpcProviders };
